import moment from 'moment';
import { get } from "lodash";

import Action from './Action';
import * as ActionMethods from './ActionMethods';

import OfferService from '../services/OfferService';
import SubscriptionService from '../services/SubscriptionService';
import LocalStorageService from '../services/LocalStorageService';
import serviceYousign from '../services/ServiceYousign';
import FileService from "../services/FileService";

import Offer from '../model/catalog/Offer';
import Subscription from '../model/catalog/Subscription';
import Error from '../model/Error';
import EventDispatcher from "../framework/EventDispatcher";
import subscriptionService from '../services/SubscriptionService';import ApplicationStore from '../framework/ApplicationStore';
import commonService from '../services/CommonService';

export const FETCH_SUBSCRIPTIONS = "FETCH_SUBSCRIPTIONS";
export const TERMINATE_SUBSCRIPTIONS = "TERMINATE_SUBSCRIPTIONS";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const GET_PROCEDURE = "GET_PROCEDURE";
export const GET_SIGNED_PDF = "GET_SIGNED_PDF";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const UPDATE_RENEWAL_SUBSCRIPTION = "UPDATE_RENEWAL_SUBSCRIPTION";

export default function reducer(state = {}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(FETCH_SUBSCRIPTIONS):
			const {subscriptionsList, currentCustomer} = action.data;
			return {
				...state,
				currentCustomer,
				subscriptionsList
			};
			break;
		case EventDispatcher.successAction(TERMINATE_SUBSCRIPTIONS):
			return {
				...state,
				customer: action.data
			};
			break;
		case EventDispatcher.successAction(UPDATE_SUBSCRIPTION):
			return {
				...state
			};
			break;
		case EventDispatcher.successAction(GET_PROCEDURE):
			return {
				...state,
				procedure: action.data
			};
			break;
		case EventDispatcher.successAction(SET_SUBSCRIPTION):
			const {subscription} = action.data;
			return {
				...state,
				subscription
			};
			break;
		case EventDispatcher.successAction(UPDATE_RENEWAL_SUBSCRIPTION):
			const {finalSubscription} = action.data;
			return {
				...state,
				subscription : finalSubscription
			};
			break;
		default:
		return state;
	}
}

export function fetchSubscriptions() {
	return (dispatch, getState) => {
		EventDispatcher.loading(dispatch, FETCH_SUBSCRIPTIONS);
		const state = getState();
		const {messages: mainMessages={}} = getState();
		const {messages = {}} = mainMessages || {};
		let currentCustomer = LocalStorageService.getCurrentCustomer();
		let subscriptionsList = [];
		SubscriptionService.listByCustomer(currentCustomer.code)
		.then(subscriptionDto => {
			const {actionStatus} = subscriptionDto;
			if (actionStatus == null || actionStatus.status === "FAIL") {
				const message = !!actionStatus ? actionStatus.message : messages["common.error.when.loading.subscriptions"];
				throw new Error({message: message});
			} else {
				const {subscriptions} = subscriptionDto;
				let {subscription} = subscriptions || {};
				subscription = subscription || [];
				subscription.forEach(sub => {
					statusList.map(status => {
						if (sub.status === status.status && status.value.toLowerCase() === "oui") {
							subscriptionsList.push(new Subscription(sub));
						}})
					});
					const offerPromises = subscriptionsList.map(sub => OfferService.find(sub.offer.code));

					return Promise.all(offerPromises.map(p => p.catch(() => undefined)));
				}
			})
			.then(offers => {
				offers = offers || [];
				offers.forEach((offerDto, index) => {
					const {actionStatus} = offerDto || {};
					if (actionStatus == null || actionStatus.status === "FAIL") {
						this.fail(actionStatus);
					} else {
						const subscription = subscriptionsList[index];
						subscription.offerTemplate = new Offer(offerDto);
					}
				});
				currentCustomer.customerAccounts.map(customerAccount => {
					const {billingAccount}= customerAccount || {};
					const {userAccount} = billingAccount || {};
					let {subscriptions} = userAccount || [];
					subscriptionsList.find(subscription => {
						if (subscription.userAccount === userAccount.code) {
							subscriptions.push(subscription)
						}})
					})

					EventDispatcher.success(dispatch, FETCH_SUBSCRIPTIONS, {currentCustomer, subscriptionsList});
			})
			.catch(error => {
				EventDispatcher.error(dispatch, FETCH_SUBSCRIPTIONS, error);
			});

				if (currentCustomer == null) {
					action.fail(new Error({ message: messages["common.error.customer.not.connected"]}));
				}
			}
		}
		export function fetchSubscriptionByCode(subscriptionCode) {
			const action = new Action(ActionMethods.FETCH_SUBSCRIPTION_BY_CODE, function (subscriptionCode) {
				let subscription = {};
				SubscriptionService.fetchSubscriptionByCode(subscriptionCode).then(subscriptionDto => {
					const {actionStatus} = subscriptionDto;
					if (actionStatus == null || actionStatus.status === "FAIL") {
						const {messages: mainMessages={}} = ApplicationStore.getState();
						const {messages = {}} = mainMessages || {};
						const message = !!actionStatus ? actionStatus.message : messages["common.error.when.loading.subscriptions"];
						throw new Error({message: message});
					} else {
						subscription = new Subscription(subscriptionDto.subscription);
						return OfferService.find(subscription.offerTemplate);
					}
				}).then(offerDto => {
					offerDto = offerDto || {};
					const {actionStatus} = offerDto;
					if (actionStatus == null || actionStatus.status === "FAIL") {
						this.fail(actionStatus);
					} else {
						subscription.offerTemplate = new Offer(offerDto);
					}
					const currentCustomer = LocalStorageService.getCurrentCustomer();
					currentCustomer.customerAccount.billingAccount.userAccount.subscriptions = [subscription];
					this.success(currentCustomer);
				}).catch(error => {
					this.fail(error);
				});
			});

	action.execute(subscriptionCode);
}

export function createSubscription(offer, services, replacedSubscription) {
	const action = new Action(ActionMethods.SUBSCRIPTION_CREATE, function (data, subscriptionCode, offer, services, replacedSubscription) {
		SubscriptionService.createSubscription(data)
		.then(actionStatus => {
			if (actionStatus === null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {

				const serviceData = {
					subscription: subscriptionCode,
					servicesToActivate: {
						service: []
					}
				};

				services.forEach(service => {
					if (service.selected) {
						serviceData.servicesToActivate.service.push({
							code: service.code,
							quantity: 1,
							subscriptionDate: data.subscriptionDate
						});
					}
				});
				let length = serviceData.servicesToActivate.service.length;
				if (length > 0) {
					SubscriptionService.subscribeService(serviceData)
					.then(actionStatus => {
						if (actionStatus === null || actionStatus.status === "FAIL") {
							this.fail(actionStatus);
						} else {
							if (replacedSubscription !== null) {
								SubscriptionService.terminateSubscription(replacedSubscription);
							}
							this.success({
								customer: fetchSubscriptionByCode(subscriptionCode),
								message: "Successfully subscribed to " + offer.name
							});
						}
					})
					.catch(error => {
						this.fail(error);
					});
				} else {
					if (replacedSubscription !== null) {
						SubscriptionService.terminateSubscription(replacedSubscription);
					}
				}
			}
		})
		.catch(error => {
			this.fail(error);
		});
	});
		const currentCustomer = LocalStorageService.getCurrentCustomer();
		if (currentCustomer === null) {
			const {messages: mainMessages={}} = ApplicationStore.getState();
			const {messages = {}} = mainMessages || {};
			action.fail(new Error({message: messages["common.error.customer.not.connected"]}));
		}
		

	const {customerAccount} = currentCustomer;
	const {billingAccount} = customerAccount || {};
	const {userAccount} = billingAccount || {};

	const subscriptionCode = "SUB_" + offer.code.toUpperCase() + "_" + moment();
	const description = !!currentCustomer ? currentCustomer.name.firstName + "'s subscription to " + offer.name + " offer." : "";
	const data = {
		code: subscriptionCode,
		description: description,
		userAccount: userAccount.code,
		offerTemplate: offer.code,
		subscriptionDate: moment().utc().format()
	};
	action.execute(data, subscriptionCode, offer, services, replacedSubscription);
}

export function updateSubscription(subscriptionData, customFields) {
	return (dispatch) => {
		EventDispatcher.loading(dispatch, UPDATE_SUBSCRIPTION);
		//const description = subscriptionData.offerTemplate.name + " offer - " + subscriptionData.code;
		const dataRenwalRule = subscriptionData.subscriptionRenewal;
		const subscriptionRenewal =  {
			initialyActiveFor: dataRenwalRule.initialyActiveFor,
			initialyActiveForUnit: dataRenwalRule.initialyActiveForUnit,
			autoRenew: dataRenwalRule.autoRenew,
			daysNotifyRenewal: dataRenwalRule.daysNotifyRenewal,
			endOfTermAction: dataRenwalRule.endOfTermAction,
			renewFor: dataRenwalRule.renewFor,
			renewForUnit: dataRenwalRule.renewForUnit,
			extendAgreementPeriodToSubscribedTillDate: dataRenwalRule.extendAgreementPeriodToSubscribedTillDate,
			terminationReasonCode: dataRenwalRule.terminationReasonCode,
		}
		let buildCustomFields =[];
		customFields.forEach(customField => {
			const data = {
				"code" : customField.code,
				"fieldType": "DATE",
				"dateValue":customField.value
			}
			buildCustomFields.push(data)
		})
		const data = {
			code: subscriptionData.code,
			description:subscriptionData.description,
			userAccount: subscriptionData.userAccount,
			offerTemplate: subscriptionData.offerTemplate.code,
			subscriptionDate: subscriptionData.subscriptionDate,
			endAgreementDate: subscriptionData.endAgreementDate,
			terminationDate: subscriptionData.terminationDate,
			terminationReason: subscriptionData.terminationReason,
			customFields: {customField: buildCustomFields},
			accesses: {access: []},
			subscriptionRenewal
		};
		SubscriptionService.updateSubscription(data)
		.then(actionStatus => {
			if (actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				EventDispatcher.success(dispatch, UPDATE_SUBSCRIPTION);
			}
		})
		.catch(error => {
			EventDispatcher.error(dispatch, UPDATE_SUBSCRIPTION, error);
		});
	}
}


export function terminateSubscription(subscription) {
	return dispatch => {
		const data = {
			subscriptionCode: subscription.code,
			terminationReason: subscription.cancel_reason ? subscription.cancel_reason : "AGREEMENT",
			terminationDate: subscription.termination_date ? subscription.termination_date : moment().utc().format()
		};
		SubscriptionService.terminateSubscription(data)
		.then(actionStatus => {
			if (actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				customer: fetchSubscriptions();
				EventDispatcher.success(dispatch, TERMINATE_SUBSCRIPTIONS, {customer});
			}
		}).catch(error => {
			EventDispatcher.error(dispatch, TERMINATE_SUBSCRIPTIONS, {error});
		});
	};
}

export function getProcedure(procedureID) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_PROCEDURE);
		serviceYousign.getProcedureByID(procedureID)
		.then(procedureDto => {
			EventDispatcher.success(dispatch, GET_PROCEDURE, procedureDto);
		})
		.catch(error => {
			EventDispatcher.error(dispatch, GET_PROCEDURE, error);
		});
	}
}

export function getSignedPdf(fileData) {
	return dispatch => {
		const {id, name} = fileData;
		EventDispatcher.loading(dispatch, GET_SIGNED_PDF);
		serviceYousign.getFileContent(id)
		.then(fileContent => {
			FileService.downloadPdf(name, fileContent);
			EventDispatcher.success(dispatch, GET_SIGNED_PDF);
		})
		.catch(error => {
			EventDispatcher.error(dispatch, GET_SIGNED_PDF, {error})
		});
	}
}

export function setSubscription(subscription) {
	return dispatch => {
		EventDispatcher.success(dispatch, SET_SUBSCRIPTION, {subscription});
	}
}

export function partialUpdateSubscription(subscriptionData) {
	return (dispatch, getState) => {
		const state = getState();
		const {subscription: {subscription={}}} = getState();
		const {subscriptionRenewal = {}} = subscription || {};
		const {renewalRule: {autoRenew}} = subscriptionData
		SubscriptionService.updatePartialSubscription(subscriptionData)
		.then(actionStatus => {
			if (actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				const finalSubscription = {
					...subscription,
					subscriptionRenewal : {
						...subscriptionRenewal,
						autoRenew
					}
				}
				EventDispatcher.success(dispatch, UPDATE_RENEWAL_SUBSCRIPTION, {finalSubscription});
			}
		}).catch(error => {
			EventDispatcher.error(dispatch, UPDATE_RENEWAL_SUBSCRIPTION, {error});
		});
	};
}


// WEBPACK FOOTER //
// ./src/opencell/actions/SubscriptionActions.js